/**
 * Returns the local attendee source from the broadcast sources.
 * @param state
 * @returns {*}
 */
export function localAttendeeSource(state) {
  const { broadcastSources, meeting } = state;
  const attendeeId = meeting?.attendeeResponse?.Attendee?.AttendeeId;
  return broadcastSources?.sources?.find(source => {
    return source.value === attendeeId;
  });
}
